import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-user",
  "use": "menu-user-usage",
  "viewBox": "0 0 16 20",
  "content": "<symbol viewBox=\"0 0 16 20\" id=\"menu-user\"><title>menu-user</title><path d=\"M10,9.8A4.85,4.85,0,0,1,5.2,4.9,4.85,4.85,0,0,1,10,0a4.85,4.85,0,0,1,4.8,4.9A4.85,4.85,0,0,1,10,9.8M2,17.53A8,8,0,0,1,6.4,10.2,8,8,0,0,0,10,11.43a6.64,6.64,0,0,0,3.6-1.23A7.82,7.82,0,0,1,18,17.39c0,3.46-16,3.46-16,.14\" transform=\"translate(-2)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-user.svg
// module id = DTTz
// module chunks = 264